import axios from "axios";
import { config } from "../constants";
import { authHeader } from "../helpers";

export const gaugeService = {
  config,
  authHeader,
  getCopayPrice,
  getCouponPrice,
  getCouponPriceForCopayCardPrescription,
  getAlternateList,
  getBrandDetailsNew,
  getGenericList,
  getGenericDetails,
  getPharmacyGroup,
  getPharmacyGroupSearchByMiles,
  getPharmacyDataById,
  getPharmacyDataByLocationId,
};

function handleResponse(response) {
  if (response.status !== 200) {
    if (response.status === 401) {
      return response;
    } else {
      const error = response.status;
      return Promise.reject(error);
    }
  }
  return response.data;
}

async function getCopayPrice(params) {
  const options = {
    baseURL: config.apiUrl,
    url: `/price/copaynew/${params.productDetailId}/${params.insuranceId}`,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    // if (error.response) {
    //   handleResponse(error.response);
    // }
    await Promise.reject(error);
  }
}

async function getCouponPrice(params) {
  const options = {
    baseURL: config.apiUrl,
    url: `/price/couponnew/${params.productDetailId}/${params.quantity || 0}/${
      params.insuranceId
    }/${params.zipCode}`,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getCouponPriceForCopayCardPrescription(params) {
  const options = {
    baseURL: config.apiUrl,
    url: `/price/prescription/${params.productDetailId}/${params.quantity || 0}/${
      params.insuranceId
    }/${params.zipCode}`,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getAlternateList(params) {
  const options = {
    baseURL: config.apiUrl,
    url: `/price/alternatenew/${params.productDetailId}/${params.insuranceId}/${params.zipCode}`,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

const updateCouponViewCount = () => {
  const couponViewCount = localStorage.getItem("coupon_view_count");

  localStorage.setItem(
    "coupon_view_count",
    1 + Number(couponViewCount ? couponViewCount : 0)
  );
};

async function getBrandDetailsNew(params) {
  updateCouponViewCount();
  const options = {
    baseURL: config.apiUrl,
    url: "adjudicate/copayoffer",
    //    headers: { "Content-Type": "application/json" },
    headers: authHeader(),
    method: "POST",
    data: {
      offerId: params.offerId,
      insuranceId: params.insuranceId,
      zipCode: params.zipCode,
      quantity: params.quantity || 0,
      productDetailId: params.productDetailId,
      pharmacyLocationId: params.pharmacyLocationId,
      prescriptionFlag: params.prescriptionFlag,
    },
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getGenericList(params) {
  let url = "";
  if (params.type === "P") {
    url = params?.sortBy
      ? `/price/pharmacynew/${params.productDetailId}/${params.quantity || 0}/${
          params.zipCode
        }/orderby/distance`
      : `/price/pharmacynew/${params.productDetailId}/${params.quantity || 0}/${
          params.zipCode
        }`;
  } else if (params.type === "M") {
    url = params?.sortBy
      ? `/price/pharmacynew/brand/${params.productDetailId}/${
          params.insuranceId
        }/${params.quantity || 0}/${params.zipCode}/orderby/distance`
      : `/price/pharmacynew/brand/${params.productDetailId}/${
          params.insuranceId
        }/${params.quantity || 0}/${params.zipCode}`;
  }
  const options = {
    baseURL: config.apiUrl,
    url: url,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getGenericDetails(params) {
  updateCouponViewCount();
  const options = {
    baseURL: config.apiUrl,
    url: "/adjudicate/cashoffer",
    method: "POST",
    headers: authHeader(),
    data: {
      productDetailId: params.productDetailId,
      quantity: params.quantity || 0,
      offerId: params.offerId,
      insuranceId: params.insuranceId,
      pbmPharmacyLocationId: params.pbmPharmacyLocationId,
      zipCode: params.zipCode,
      pbmProductDetailId: params.pbmProductDetailId,
      pharmacyGroupPbmId: params.pharmacyGroupPbmId,
      pbmId: params.pbmId,
    },
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getPharmacyGroup(zipcode) {
  const options = {
    baseURL: config.apiUrl,
    url: `/price/pharmacygroup/list/${zipcode}`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getPharmacyGroupSearchByMiles(zipcode, searchMileRadius) {
  const options = {
    baseURL: config.apiUrl,
    url: `/price/pharmacygroup/list/${zipcode}/${searchMileRadius}`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getPharmacyDataById(pharmacyGroupId) {
  const options = {
    baseURL: config.apiUrl,
    url: `/price/pharmacygroup/${pharmacyGroupId}`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getPharmacyDataByLocationId(pharmacyLocationId) {
  const options = {
    baseURL: config.apiUrl,
    url: `/price/pharmacylocation/${pharmacyLocationId}`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}
